import { DetectionTypeEnum } from '../enums/detection-type-enum';
import { SatelliteOrbitEnum } from '../enums/satellite-orbit-enum';
import { PeriodValueObject } from '../value-objects/period-value-object';

export class DetectionConfigEntity {
  type!: DetectionTypeEnum;
  orbitOptions: SatelliteOrbitEnum[] = [];
  period: PeriodValueObject = { start: null, end: null };
  orbit: SatelliteOrbitEnum | null = null;
  forestMapYear: number = 2019;
  forestCoveragePercent: number = 75;

  constructor(init?: Partial<DetectionConfigEntity>) {
    Object.assign(this, init);
  }
}
